import axios from "../helpers/axios";
import { CampPosition, CampPositionsResponse } from "../types/campPosition";

export const getCampPositions = async (
  userId: string,
  type: string
): Promise<CampPosition[]> => {
  const { data } = await axios.get<CampPositionsResponse>(
    `/admin/camp/users/${userId}/positions`,
    {
      params: {
        type,
        includeUnrealisedGain: "true",
      },
    }
  );
  return data.positions ?? [];
};
